'use strict';

const WidgetTypes = {
    Fixed: 'fixed',
    BuiltIn: 'built-in'
};

export default WidgetTypes